<template lang="pug">
  b-timepicker(v-model="time" inline size="is-small")
</template>

<script>
export default {
  name: 'timepicker',

  computed: {
    time: {
      get() {
        if (this.$attrs.value === null) {
          return null;
        }

        const date = new Date();

        date.setHours(Math.floor(this.$attrs.value / 3600));
        date.setMinutes(Math.floor((this.$attrs.value % 3600) / 60));

        return date;
      },
      set(time) {
        if (time === null) {
          this.$emit('input', null);

          return;
        }

        this.$emit('input', time.getHours() * 3600 + time.getMinutes() * 60);
      },
    },
  },
};
</script>
